import React, {useState} from 'react';
import * as css from './Checkbox.css';

function Checkbox({classes, onClick, color, selected, disabled = false} ) {
    const [border, setBorder] = useState('');

    const updateSelected = (e) => {
        e.stopPropagation();
        setBorder(' border');
        setTimeout(() => {
            setBorder('');
        }, 300);
        if(onClick && !disabled)
            onClick(!selected);
    };

    return (
        <css.checkbox data-cy ={(classes ? classes : 'classicCheckbox')} className={(classes ? classes : 'classicCheckbox') + (selected ? ' selected' : '') + border + (disabled ? ' disabled' : '')} onClick={updateSelected} color={color}/>  
    );
}
export default Checkbox;
